class CustomColumnsCarouselComponent extends HTMLElement {
  constructor() {
    super();
    this.initPages();
  }
  initPages() {
    var bannerSplide = new Splide(this.querySelector('.splide'), {
      type: 'loop',
      pagination : true,
      gap : 185,
      fixedWidth : 605,
      focus: 'center',
      autoHeight: true,
      arrows: true,
      breakpoints : {
        1200: {
          gap : 85,
        },
        989: {
          perPage: 1,
          perMove: 1,
          fixedWidth : false,
          padding: false,
          gap: false
        }
      }
    });
    
    bannerSplide.mount();
  }
}

customElements.define('columns-carousel', CustomColumnsCarouselComponent);